import { RuleTranslations } from "./models/rule-translaction-model";
import { SupportedLanguages } from "@/lang/lang-settings";
import { ptBR } from "./translactions/pt-BR";
import { enUS } from "./translactions/en-US";

export const rule: Record<SupportedLanguages, RuleTranslations> = {
  'pt-BR': ptBR,
  'en-US': enUS,
};
